module.exports = __webpack_public_path__ + "static/media/WhiteEveningSun.18b6ee40.jpg";